import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router, Route, Link } from 'react-router-dom';
import { Auth } from '../services/auth-service';

export class Navigation extends React.Component {
  render() {
    // inherit auth service and check auth status to display correct link
    // if( !this.props.authService.isAuthenticated() )
    //   return (<div><Link className="navItem" to="/login">Login / Register</Link></div>);
    // else
      return (<div>
          <Link className="navItem" to="/logout">Logout</Link>
          <Link className="navItem" target="_blank" to="http://docs.hypersocio.com">Help</Link>
          <Link className="navItem" to="/sociogram">My Sociograms</Link>
          <Link className="navItem" to="/people">Manage People</Link>
          <Link className="navItem" to="/entries">Enter Socio Data</Link>
          <Link className="navItem" to="/">Home</Link>
        </div>);
    
  }
}